const config = {
  // API_URL: "http://localhost:5010",
  // API_URL: "http://192.168.178.28:5010",
  API_URL: "https://tastyreform.hu",
  API_VERSION: "/api/v1",
  PUBLIC_FOLDER: "/static",
};
export default config;
